import {Component, OnInit, Inject, Output, EventEmitter, ChangeDetectorRef} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import { Subscription, Observable, of } from 'rxjs';
import { StateService } from '../../../services/state.service';
import { UtilitaryService } from '../../../services/utilitary.service';
import { Router } from '@angular/router';
import { formatDate, DatePipe } from '@angular/common';
import { AtylService } from '../../service/atyl.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PrintDialog } from '../../../views/partials/layout/dialog/print-dialog.component';
import {  MatProgressSpinnerModule  } from '@angular/material';

import { ConfirmComponent } from '../../../views/partials/layout/dialog/confirm.component'
import { DialogService } from '../../../services/dialog-service.service';
import { BaseDialogComponent } from '../../../base/dialog-base/dialog-base.component'
import * as moment from 'moment'
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS
} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { LOCALE_ID } from '@angular/core';

@Component({
    selector: 'form-dialog-formulaire',
    styleUrls: ['./form-dialog-formulaire.component.css'],
    templateUrl: 'form-dialog-formulaire.component.html',
	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
export class FormDialogFormulaireComponent extends BaseDialogComponent implements OnInit {
  loadingPrint:boolean= false;
  dateForm: any;
  title: string = "";
  atylComponents: string = "";
  atylTemplate: string = "";
  atylDocuments: string = "";
  atylDemand: any;
  atylDossier: any;
  actionForm: string ="";
  statusForm: string = "1";
  avisForm: string = "0";
  
  id: string = "";
  typeDemande: string = "";
  typeFormulaire: string = "";
  nextState: string = "";
  currentForm: any;
  loading: boolean = true;
  changeUrl: boolean = false;
  subscription: Subscription;
  demande: any;
  isEditable: boolean = true;
  isHistoric: boolean = false;
   
  hasSaveButton: boolean = true;
  @Output() submited = new EventEmitter<any>();
 
  formData:any;
  formChanged:boolean=false;
  formValid:boolean=false;
  
  
  constructor(
    
	@Inject(MAT_DIALOG_DATA) public data: any,
    private atylService: AtylService,
    private stateService: StateService,
    public changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private utilities: UtilitaryService,
    private datePipe: DatePipe,
    private snackbar: MatSnackBar,
  //  private dialog: MatDialog,
	public dialogService: DialogService,
	public dialogRef: MatDialogRef<FormDialogFormulaireComponent>,
    //IMPORTANT : le moteur atyl est un composant dynamique, pour que l'appli render les changements,
    //            il faut lui spécifier qu'il faut une attention particulière au component
    //            ChangeDetectorRef nous permet de faire les check manuellement pour garantir la construction des composants dynamiques
    ){
			super(dialogRef, dialogService, changeDetectorRef)

	}

  ngOnInit() {
	this.dialogRef.disableClose = true
    this.atylComponents = "";
    this.atylTemplate = "";
    this.atylDocuments = "";
    this.atylDemand = "";
    this.typeDemande = this.data.typeDemande;
    this.typeFormulaire = this.data.typeFormulaire;
    this.title = this.data.title;
    this.atylService.updateDossier(this.data.dossierId);
    
     if ((this.atylDossier == undefined || !this.atylDossier) && this.data.dossier != undefined && this.data.dossier) {
			this.atylDossier = this.data.dossier 
     }
    
    if(this.data.form)
    {
      this.atylService.getFormulaireByID(this.data.demandeFormulaire.ID).subscribe((res) => {
        if(res.result){
          this.dateForm = this.datePipe.transform(res.result.creationdate) ;
          this.atylComponents = JSON.stringify(res.result.form.fields);
          this.atylTemplate = res.result.form.template;
          this.atylDocuments = JSON.stringify(res.result.form.documents);
          this.atylDemand = res.result.form;
          this.demande = res.result;
		  res.result.form.demande=this.demande;
		  
          this.currentForm = res.result.form;
          this.actionForm = "formulaire:set";
          if(res.result.status != undefined && res.result.status !=0){
            this.statusForm = String(res.result.status);
          }
          if(res.result.favorable != undefined)
            this.avisForm = String(res.result.favorable);
        }else {
				  if (res.error) {
					  let message:string=(res.error.data!=undefined) ? res.error.data : res.error.message;
					  let snackBarRef = this.snackbar.open(message,'', {
				                duration: 30000
				              });
				     
				       this.dialogRef.close();
									  
					}
		}			
        this.loading = false;
        this.changeDetectorRef.detectChanges();
      });
    }
    else if(this.data && this.data.loadedForm){
      console.log(this.data.loadedForm);
      this.atylComponents = JSON.stringify(this.data.loadedForm.form.fields);
      this.atylTemplate = this.data.loadedForm.form.template;
      this.atylDocuments = JSON.stringify(this.data.loadedForm.documents);
      this.atylDemand = this.data.loadedForm;
      this.demande = this.data.loadedForm;
      this.actionForm = "formulaire:set";
      this.loading = false;
      this.changeDetectorRef.detectChanges();
    }
    else
    {

      this.atylService.getForm(this.data.typeFormulaire, this.data.dossierId)
      .subscribe(formulaire => {
          this.atylComponents = JSON.stringify(formulaire.result.form.fields);
          this.atylTemplate = formulaire.result.form.template;
          this.atylDocuments = JSON.stringify(formulaire.result.documents);
          this.atylDemand = formulaire.result;
          this.demande = formulaire.result;
          this.hasSaveButton = false;
          this.actionForm = "formulaire:set";
          this.loading = false;
          this.changeDetectorRef.detectChanges();
      });
    }
    if(this.data && this.data.isEditable !== undefined)
      this.isEditable = this.data.isEditable;
	if(this.data && this.data.isHistoric !== undefined)
		 this.isHistoric = this.data.isHistoric;
	

			/*
			this.dialogRef.backdropClick().subscribe((evt:any)=> {
					console.log("FormDialogFormulaireWithSFComponent backdropClick",evt,this.formChanged);
							
							if (this.formChanged && this.isEditable) {
								this.dialogService.open(ConfirmComponent, {
													data: {
														// libelle: 'Souhaitez-vous valider votre saisie ?'
									          libelle: "Vous avais modifié des données êtes-vous sur de vouloir quitter ?"
													},
													
												}, (res: any) => {
													
												if (res === 'true') {
										                    this.dialogRef.close();
										     }
														
													
								});
								
							}	else
									this.dialogRef.close();
		})
	*/
	
  }

  ngAfterViewInit() {
  }
  
  onLoaded(loaded: boolean){
    if(loaded)
        this.changeDetectorRef.markForCheck();
  }
  ngOnDestroy() {
    if(this.subscription)
      this.subscription.unsubscribe();
  }

  canDeactivate(): Observable<boolean> | boolean {
    let i = 0;

    if(this.atylDemand && this.atylDemand.form && this.atylDemand.form.fields && this.atylDemand.form.fields.length > 0){
      this.utilities.log(this.atylDemand.form.fields);
      this.atylDemand.form.fields.forEach((field) => {
        if (field.value && field.value != "")
          i++
      })
    }
    if(i != 0 && !this.changeUrl)
      return of(window.confirm("Voulez-vous abandonner le formulaire en cours ?"));
    else
      return true;
  }
  
  onSubmit(values: any) {
    this.loadingPrint=true;
    console.log(values,"values");
    this.atylDemand.documents = values.DOCUMENTS;
    if(!values["close"])
      this.data.closeWhenValidate = false;
    else if(values['close'])
      this.data.closeWhenValidate = true;
    if(this.currentForm)
      this.atylDemand.form = this.currentForm;
    for(var i=0;i<this.atylDemand.form.fields.length;i++) {
      var field=this.atylDemand.form.fields[i];
      if (values.hasOwnProperty(field.ID)) {
        var val=values[field.ID];
		
		if ( val == '' || val == undefined) {
				val = null
			}
		
        if (field.field.type=='date'
        && val!=undefined
         && val != "") {
          var utcDate=formatDate(val,"yyyy-MM-ddTHH:mm:ss","fr-FR");
           console.log("FormDialogFormulaireComponent date submit",field,utcDate,val, typeof val);
          if (val instanceof moment ) {
						var momentObj = moment(val);
						utcDate=momentObj.utcOffset(0, false).format("YYYY-MM-DDTHH:mm:ss")+"Z"
		}
		
							
					
		  console.log("FormDialogFormulaireComponent date submit",field,utcDate,val);
          val=utcDate;
        }
		
		if (	 field.field.type == 'selectionlist'  															) 
												{
						console.log("submit selection list bedore",val)	
						if (val==undefined || val=="" || val==null)
							val=[];
						
		}
        
        field["value"]=val;
        this.atylDemand.form.fields[i]=field;
      }
    }
    if(this.currentForm){
      this.atylDemand.form = {
        form: this.currentForm.ID,
        key: this.currentForm.key
      }
    }
    if(this.nextState)
      this.atylDemand.transition = this.nextState;
      if(!this.atylDemand.ID){
        this.atylService.setNewFormulaire(this.typeFormulaire,this.atylDemand.form.fields, (this.data.instruction && this.data.instruction.ID ? this.data.instruction.ID : ''),null,values.etat)
        .subscribe(submitted => {
         	if (submitted.error!=undefined) {
					  let message:string=(submitted.error.data!=undefined) ? submitted.error.data : submitted.error.message;
					  let snackBarRef = this.snackbar.open(message,'', {
				                duration: 30000
				              });
				     
				       this.dialogRef.close();
									  
		} else {
          this.loadingPrint=false;
          	this.submited.emit(submitted)
						this.snackbar.open('Formulaire enregistré', '', {
							duration: 10000
						})
			if (this.data && this.data.closeWhenValidate)
				this.dialogRef.close(submitted)
			else {
				
				console.log("onSubmit on submit before without close",submitted.result);
					if (submitted.result ) {
						this.data.create=false;
						this.data.v3=false;
						if( submitted.result.parent!=undefined
						&& submitted.result.parent.ID!=undefined) {
							
							this.data.id=submitted.result.parent.ID;
							
						} else {
							
							if (
								submitted.result.form!=undefined
								&& submitted.result.form.is_form!=undefined
								&& !submitted.result.form.is_form
								&& submitted.result.ID!=undefined)
									this.data.id=submitted.result.ID;
							
						}
						
						console.log("onSubmit on submit without close", this.data);
						this.ngOnInit()
					}
			}
			
			 }
			 this.changeDetectorRef.detectChanges();
          
          
        });
      }
      else{
        this.atylService.setFormulaire(this.atylDemand, this.data.instruction, this.data.demandeFormulaire.ID, values.etat, '', values.favorable,this.isHistoric).subscribe( (res) => {
        if (res.error!=undefined) {
					  let message:string=(res.error.data!=undefined) ? res.error.data : res.error.message;
					  let snackBarRef = this.snackbar.open(message,'', {
				                duration: 30000
				              });
				     
				 this.dialogRef.close();
									  
		} else {
        
          this.submited.emit(res.result);
          this.changeUrl = true;
   		this.loadingPrint=false;
          let snackBarRef = this.snackbar.open('Formulaire enregistré','', {
            duration: 10000
          });
          if(this.data.closeWhenValidate)
            this.dialogRef.close(res.result);
         }
          this.changeDetectorRef.detectChanges();
        })
      }
    
  }

  getSubmittedEmitter() {
    return this.submited;
  }

  CheckSendDossier(type: string) {
    if(type == "RENOUVELLEMENT" || type == "MODIFICATION" || type == "DEMENAGEMENT" || type == "INITIALE")
      return true
    else
      return false
  }
  
  printForm(id:any){
    this.atylService.printFormulaire(id, true,false).subscribe((res) => {
      this.loadingPrint=false;
      if(res.result && res.result.length > 0)
        window.open(res.result[0].value.url);
      else
        of(window.confirm("Pas de donnée disponible"));
    });
  }
  
  onChanged(changed: any) {
  	this.formChanged=false;
  	this.formValid=false;
  	
  	
  	if (this.formData!=changed.data) {
  		   this.formChanged=true;
  		this.formData=changed.data;
  		this.formValid=changed.valid;
  		
  	}	
  	
  	this.changeDetectorRef.detectChanges();
  }
  
  closeForm() {
  				if (this.formChanged) {
  									this.dialogService.open(ConfirmComponent, {
  														data: {
  															// libelle: 'Souhaitez-vous valider votre saisie ?'
  										          libelle: "Vous avais modifié des données êtes-vous sur de vouloir quitter ?"
  														},
  														
  													}, (res: any) => {
  														
  													if (res === 'true') {
  											                    this.dialogRef.close();
  											     }
  															
  														
  									});
  									
  			}else
  									this.dialogRef.close();
  	 }
  
}